import { render, staticRenderFns } from "./vue-confirm-dialog.vue?vue&type=template&id=3db1d6b0"
import script from "./vue-confirm-dialog.vue?vue&type=script&lang=js"
export * from "./vue-confirm-dialog.vue?vue&type=script&lang=js"
import style0 from "./vue-confirm-dialog.vue?vue&type=style&index=0&id=3db1d6b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports